export default __webpack_public_path__ + "static/media/seja-nosso-parceiro.aca2e165.jpg";